import { Search } from "lucide-react";

interface SearchPillProps {
  onClick?: VoidFunction;
  label?: string;
  shortcut?: string;
}

export function SearchPill({
  onClick,
  label = "Search for a patient",
  shortcut = "⌘/",
}: SearchPillProps) {
  return (
    <button
      onClick={onClick}
      className="bg-surface-muted hover:bg-surface-ghost-hover rounded-12 typo-title-md text-typography-secondary flex cursor-pointer items-center gap-2.5 px-4 py-2.5 transition-all duration-150 ease-out"
    >
      <Search className="size-[17px] shrink-0" />
      <span className="whitespace-nowrap">{label}</span>
      <span className="ml-1">{shortcut}</span>
    </button>
  );
}
